import { formatEventDates, Locales, TicketingFormCategory } from "@simplyk/common";
import { DateTime } from "luxon";

import { EventRow, EventRowEvent } from "./useEventRowsTab";

export type EventRowDisplay = {
  row: EventRow;
  event: EventRowEvent;
  formattedDate: string;
};

export type EventRowsDay = {
  dayKey: string;
  dayLabel: string;
  weekdayLabel: string;
  rows: EventRowDisplay[];
};

export const groupEventRowsByDay = ({
  rows,
  eventsById,
  locale,
}: {
  rows: EventRow[];
  eventsById: Map<string, EventRowEvent>;
  locale: Locales;
}): EventRowsDay[] =>
  rows.reduce<EventRowsDay[]>((days, row) => {
    const event = eventsById.get(row.ticketingId);
    if (!event) {
      return days;
    }

    const isAuction = event.formCategory === TicketingFormCategory.Auction;
    const startUtc = new Date(row.startUtc);
    const endUtc = new Date(row.endUtc);
    const timezone = event.eventTimezone || undefined;
    const { formattedDate } = formatEventDates([{ startUtc, endUtc }], timezone, {
      locale,
      showOnlyEndDate: isAuction,
    });
    const shownDay = DateTime.fromJSDate(endUtc, { zone: timezone }).setLocale(locale);
    const dayKey = shownDay.toISODate() ?? row.occurrenceId;
    const rowDisplay = { row, event, formattedDate };

    const lastDay = days.at(-1);
    if (lastDay?.dayKey === dayKey) {
      lastDay.rows.push(rowDisplay);
      return days;
    }

    return [
      ...days,
      {
        dayKey,
        dayLabel: shownDay.toFormat("MMM d").toUpperCase(),
        weekdayLabel: shownDay.toFormat("cccc"),
        rows: [rowDisplay],
      },
    ];
  }, []);
